import { isVttView } from "@/constants";
import { ensureAudioContextStarted } from "@/helpers/playSound";
import type { User } from "@dndbeyond/auth/types/user";
import { useEffect, useRef } from "react";

export const useAudioStartListener = (user?: User) => {
  const hasAudioStarted = useRef(false);

  useEffect(() => {
    if (isVttView || !user || hasAudioStarted.current) return;

    const unlock = () => {
      void (async () => {
        if (hasAudioStarted.current) return;

        const started = await ensureAudioContextStarted();

        if (!started) return;

        hasAudioStarted.current = true;

        cleanup();
      })();
    };
    const events: Array<keyof WindowEventMap> = [
      "pointerdown",
      "touchstart",
      "mousedown",
      "keydown",
    ];
    const cleanup = () => {
      events.forEach((eventName) => {
        window.removeEventListener(eventName, unlock, true);
      });
    };

    events.forEach((eventName) => {
      window.addEventListener(eventName, unlock, {
        capture: true,
        passive: true,
      });
    });

    return cleanup;
  }, [user]);
};
